import { Component, Input } from '@angular/core';
import { StatusTextType } from './status-text.model';

@Component({
  selector: 'app-status-text',
  templateUrl: './status-text.component.html',
  styleUrls: ['./status-text.component.scss'],
  // eslint-disable-next-line
  standalone: false,
})
export class StatusTextComponent {
  @Input() text = '';
  @Input() type!: StatusTextType;

  constructor() {}

  get className() {
    switch (this.type) {
      case StatusTextType.Notification: {
        return 'status-text notification';
      }
      case StatusTextType.Info: {
        return 'status-text info';
      }
      case StatusTextType.Warning: {
        return 'status-text warning';
      }
      case StatusTextType.Completed: {
        return 'status-text completed';
      }
      case StatusTextType.Failed: {
        return 'status-text failed';
      }
      case StatusTextType.Success: {
        return 'status-text success';
      }
      case StatusTextType.New: {
        return 'status-text new';
      }
      case StatusTextType.Price: {
        return 'status-text price';
      }
      case StatusTextType.White: {
        return 'status-text white';
      }
      case StatusTextType.None: {
        return 'status-text';
      }
    }
  }
}
